type FrequentTopicProp = {
  topic: string;
};

const FrequentTopic = ({ topic }: FrequentTopicProp) => {
  return (
    <div className="inline transition duration-300 bg-subColor4 text-subColor3 rounded-lg text-[10px] py-1 px-2 whitespace-nowrap">
      {topic}
    </div>
  );
};

export default FrequentTopic;
